import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AuthService} from 'src/authentication/service/auth.service';

@Component({
  selector: 'dcu-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
  ) {
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.loginForm = this.fb.group({
      userName: [null],
      password: [null]
    });
  }

  onLogin() {
    if (this.loginForm.valid) {
      const param = this.loginForm.getRawValue();
      this.authService.login(param).subscribe((res: boolean) => {
        if (res) {
          this.authService.gotoPage();
        }
      });
    }
  }
}
